import React, {Component} from "react"
import {withRouter, RouteComponentProps} from "react-router-dom"
import {LandingContainer} from "../landing-container/landing-container";
import NewWord from "../landing-content/new-word";
import Button from "@material-ui/core/Button";
import {Helmet} from "react-helmet";
import pizza from '../img/HR_Labra..png'
import pasta from '../img/LABRA_HR.png'


interface HrProps extends RouteComponentProps {}

export class Hr extends Component<HrProps> {
    render() {
        return (
            <>
                <Helmet>
                    <title>LABRA HR - Система управления персоналом и Performance Management с AI | HR-аналитика</title>
                    <meta name="description" content="LABRA HR - интегрированная система управления персоналом с AI-аналитикой. Повышение производительности труда на 25%, автоматизация HR-процессов, KPI сотрудников, матрица компетенций и аттестация персонала."/>
                    <meta name="keywords" content="система управления персоналом, HR аналитика, производительность труда, performance management, управление эффективностью, автоматизация HR, KPI сотрудников, staffing, аттестация персонала, матрица компетенций, обеспечение персоналом, HR процессы"/>

                    {/* Open Graph */}
                    <meta property="og:title" content="LABRA HR - Система управления персоналом и performance management"/>
                    <meta property="og:description" content="HR-аналитика, performance management, KPI сотрудников и автоматизация HR-процессов с AI. Повышение производительности на 25%."/>
                    <meta property="og:type" content="website"/>
                    <meta property="og:url" content="https://www.labrahub.ru/#/hr"/>
                    <meta property="og:image" content="https://www.labrahub.ru/images/logos/LABRA_HR.png"/>

                    {/* Twitter Card */}
                    <meta name="twitter:card" content="summary_large_image"/>
                    <meta name="twitter:title" content="LABRA HR - Система управления персоналом и performance management"/>
                    <meta name="twitter:description" content="HR-аналитика, performance management, KPI сотрудников и автоматизация HR-процессов с AI"/>
                    <meta name="twitter:image" content="https://www.labrahub.ru/images/logos/LABRA_HR.png"/>
                </Helmet>
                <LandingContainer titleText={"LABRA HR — Управление эффективностью ручного труда"} titleStyle={{'fontSize': 'xxx-large'}}>
                <div className="landing-section">
                    <div className="landing-section-content">
                        <div>
                            <p><b>LABRA HR</b> анализирует работу сотрудников на ручном производстве через камеры наблюдения,
                            автоматически создает фотографию рабочего дня и рассчитывает KPI.
                            Система снижает затраты на персонал на <b>15%</b> и повышает эффективность работы кадров на <b>75%</b>.</p>
                            <p>Performance Management на основе реальных данных: хронометраж операций,
                            нормирование труда, оценка производительности, объективная аттестация персонала
                            и оптимальное обеспечение персоналом.</p>
                        </div>
                        <h4>ПРИНЦИП РАБОТЫ <img src={pasta} style={{width: 130, marginBottom: 13}}/></h4>
                        <div style={{textAlign: 'center', marginBottom: 30}}>
                            <img className="news-card-picture"
                                 src={pizza}
                                 alt="LABRA"
                            />
                        </div>
                        <ol>
                            <li>Захват изображений с камер наблюдения и первичная разметка операций</li>
                            <li>Работа машинного обучения по анализу поступившего видео</li>
                            <li>Создание фотографии рабочего дня по видео, автоматический расчет аналитики.</li>
                            <li>Формирование итогового отчета с выявленными ресурсами для повышения безопасности,
                                содержательности и качества использования трудовых ресурсов.
                            </li>
                            <li>Улучшение использования и планирования трудовых ресурсов компании, увеличение отдачи от
                                сотрудников
                            </li>
                        </ol>
                    </div>
                </div>
                <div className="landing-section">
                    <div className="landing-section-content">
                        <h4>КАКИЕ ПРОБЛЕМЫ УПРАВЛЕНИЯ ПЕРСОНАЛОМ И ЭФФЕКТИВНОСТИ РЕШАЕТ HR-АНАЛИТИКА <img src={pasta} style={{width: 130, marginBottom: 13}}/></h4>
                        <ul>
                            <li>Недостаточная производительность труда;</li>
                            <li>Использование трудовых ресурсов (персонала и времени) не на максимум эффективности;</li>
                            <li>Недостаточная эффективность работы персонала;</li>
                            <li>Невозможность расчета точной необходимой численности персонала для выполнения конкретных
                                задач;
                            </li>
                            <li>Проблемы мотивации персонала;</li>
                            <li>Негибкость и устаревание системы оплаты труда;</li>
                            <li>Проблемы организации трудовых процессов;</li>
                            <li>Повышенные издержки производственного процесса;</li>
                            <li>Повышенные издержки на персонал;</li>
                            <li> Низкая «отдача» от персонала, отсутствие инновационных предложений;</li>
                            <li>Проблемы инфраструктуры взаимодействия внутри компании</li>
                            <li>Проблемы лояльности сотрудников.</li>
                        </ul>
                    </div>
                </div>
            </LandingContainer>
            </>
        )
    };
}

export default withRouter(Hr)
